import { useMemo } from "react";
import { BusinessLineToPhaseMapping } from "../constants/BusinessLineToPhaseMapping";
import { useAppSelector } from "./reduxHooks";

export function useFindRecommendedPhases() {
    const sharedState = useAppSelector((state) => state.shared);

    const recommendedPhases = useMemo(() => {
        if (!sharedState.baseInfo?.phaseList) {
            return [];
        }

        const recommendedPhases = [];

        const phaseList = sharedState.baseInfo?.phaseList;

        const businessLine =
            sharedState.accountDetail?.businessLines?.map((b) =>
                sharedState.businessLines.find((bl) => bl.id === b)
            ) ?? [];

        const recommended = BusinessLineToPhaseMapping.filter((b) =>
            businessLine.some(
                (bl) =>
                    bl?.title.trim() == b.ChildTitle.trim() ||
                    bl?.title.trim() == b.ParentTitle.trim()
            )
        );

        return phaseList.filter((p) =>
            recommended.some((r) => r.recommendedPhaseForSale.includes(p.title))
        );
    }, [
        sharedState.baseInfo?.phaseList,
        sharedState.accountDetail?.businessLines,
        sharedState.businessLines,
    ]);

    return recommendedPhases;
}
